// filepath: /c:/Users/joanr/Desktop/pagina web de blog para adsense/mi-app/src/pages/Home.js
import React, { useEffect } from 'react';
import './Home.css';
import DivCardHome from '../components/DivCardHome';
import QuestionDivHome from '../components/QuestionDivHome';


const Home = () => {
  useEffect(() => {
    const image = document.querySelector('.cards-image');
    const handleMouseMove = (e) => {
      const { clientX, clientY } = e;
      const { left, top, width, height } = image.getBoundingClientRect();
      const x = ((clientX - left) / width - 0.5) * 30; // Ajusta el valor para cambiar la intensidad del movimiento
      const y = ((clientY - top) / height - 0.5) * 30; // Ajusta el valor para cambiar la intensidad del movimiento
      image.style.transform = `translate(-50%, -50%) rotateY(${x}deg) rotateX(${-y}deg)`;
    };
    image.addEventListener('mousemove', handleMouseMove);
    return () => {
      image.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  

  return (
    <div className="container">
      <header className="hero-section">
        <div className="text-container">
          <h1 className="main-title">Transforma tu Negocio con Nuestra Agencia de Marketing Digital e IA</h1>
          <p className="subtitle">
            Nuestro equipo puede ayudarte a implementar estrategias efectivas de marketing digital y soluciones de inteligencia artificial para tu negocio.
          </p>
          <div className="cta-buttons">
            <button className="btn open-card">Conoce nuestros servicios</button>
            <button className="btn get-started">Empieza ahora</button>
          </div>
        </div>
        <div className="image-container">
        <img src="https://firebasestorage.googleapis.com/v0/b/app-cleaning-9c173.firebasestorage.app/o/wenowsocial-images%2F29.png?alt=media&token=4aacfc40-542e-4cc7-a683-f7a0932e2878" alt="Servicios de Marketing Digital e IA" className="cards-image" />
        </div>
      </header>
      <DivCardHome />
      <QuestionDivHome />
      
    </div>
  );
};

export default Home;